export const KYC_IN_REVIEW_IDV_SUBMITTED_EVENTS = {
  VIEW_KYC_IN_REVIEW_IDV_SUBMITTED_PAGE: 'view_kyc_in_review_idv_submitted',
  VIEW_KYC_IN_REVIEW_IDV_SUBMITTED_FIRST_MESSAGE:
    'view_kyc_in_review_idv_submitted_first_message',
  VIEW_KYC_IN_REVIEW_IDV_SUBMITTED_SECOND_MESSAGE:
    'view_kyc_in_review_idv_submitted_second_message',
  SELECT_KYC_IDV_PROCESSING_WAIT: 'select_kyc_idv_processing_wait',
  SELECT_KYC_IDV_PROCESSING_NOTIFY_ME: 'select_kyc_idv_processing_notify_me',
} as const;
